import React from 'react';
import useAdScriptsSequentiallyWithWait from './hooks/useAdScriptsSequentially';
import usePushSdkLoader from './hooks/usePushSdkLoader';

const AdLoader = () => {
  const adScripts = [
    { domain: 'groleegni.net', zone: 9420953 },
    { domain: 'gizokraijaw.net', zone: 9420949 },
    // {
    //   domain: 'vemtoutcheeg.com',
    //   zone: 9251005,
    //   path: '400',
    //   selectorToWaitFor: '#ad-slot-9251005',
    
    //   src: '//pl26836017.profitableratecpm.com/bc/08/a4/bc08a46fd731eedd8aa4cdf581a9a6a1.js',
    // },
    {
      src: '//pl26930301.profitableratecpm.com/4d/63/b1/4d63b1041be168cabc84beb1c587b1e2.js',
    },
    {
      src: '//pl26935554.profitableratecpm.com/9a/9d/1a/9a9d1a9db746217ecbf1c65a858261df.js',
    }
  ];



  useAdScriptsSequentiallyWithWait(adScripts, {
    delay: 1500,
    waitForSelector: '#ad-container', // wait before injecting each script (optional)
  });

  // usePushSdkLoader(1553817); // load the push SDK

  return (
    <div>
      <div id="ad-slot-9251005" />
    </div>
  );
};

export default AdLoader;
